import Vue from 'vue';
import Router from 'vue-router';
import Welcome from '@/components/Welcome';
import About from '@/components/About';
import RasterFileConverter from '@/components/converter/RasterFileConverter';
import VectorFileConverter from '@/components/converter/VectorFileConverter';
import WMSConverter from '@/components/converter/WMSConverter';
import WFSConverter from '@/components/converter/WFSConverter';
import QueueStats from '@/components/QueueStats';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'welcome',
      component: Welcome,
    },
    {
      path: '/about-us',
      name: 'about',
      component: About,
    },
    {
      path: '/raster',
      name: 'raster',
      component: RasterFileConverter,
    },
    {
      path: '/vector',
      name: 'vector',
      component: VectorFileConverter,
    },
    {
      path: '/wms',
      name: 'wms',
      component: WMSConverter,
    },
    {
      path: '/wfs',
      name: 'wfs',
      component: WFSConverter,
    },
    {
      path: '/queue',
      name: 'queue',
      component: QueueStats,
      props: { queueName: 'default', small: false },
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js